import * as Yup from 'yup';

import { createLocale } from 'locales';

const globalLocalize = createLocale('global');
const rePhoneNumber =
  /(^\+[0-9]{2}|^\+[0-9]{2}\(0\)|^\(\+[0-9]{2}\)\(0\)|^00[0-9]{2}|^0)([0-9]{9}$|[0-9\-\s]{10}$)/;
const rePostalCode = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i;

export default Yup.object().shape({
  about: Yup.string()
    .max(255)
    .required(globalLocalize('fieldRequiredErrorMessage')),

  city: Yup.string().required(globalLocalize('fieldRequiredErrorMessage')),

  firstName: Yup.string()
    .required(globalLocalize('fieldRequiredErrorMessage'))
    .max(30, globalLocalize('maxLengthFieldError', { count: '30' })),

  houseNumber: Yup.number()
    .typeError(globalLocalize('numberTypeError'))
    .required(globalLocalize('fieldRequiredErrorMessage')),

  lastName: Yup.string()
    .required(globalLocalize('fieldRequiredErrorMessage'))
    .max(30, globalLocalize('maxLengthFieldError', { count: '30' })),

  phoneNumber: Yup.string()
    .matches(rePhoneNumber, globalLocalize('phoneNumberInvalidErrorMessage'))
    .required(globalLocalize('fieldRequiredErrorMessage')),

  postalCode: Yup.string()
    .matches(rePostalCode, globalLocalize('postalCodeInvalidErrorMessage'))
    .required(globalLocalize('fieldRequiredErrorMessage')),

  street: Yup.string().required(globalLocalize('fieldRequiredErrorMessage')),
});
